<!-- src/components/StatsPanel.svelte -->
<script>
  import { agentStore } from '$lib/stores'

  $: totalRuns = $agentStore.runs.length
  $: activeRuns = $agentStore.runs.filter(r => r.status === 'running').length
  $: completedRuns = $agentStore.runs.filter(r => r.status === 'completed').length
  $: failedRuns = $agentStore.runs.filter(r => r.status === 'failed').length
  $: outsourcedRuns = $agentStore.runs.filter(r => r.status === 'outsourced').length
  $: totalTokens = $agentStore.runs.reduce((sum, r) => sum + (r.tokens_used || 0), 0)

  const stats = [
    { label: 'Total Runs', value: totalRuns, icon: '⚡', color: '#7c5cff' },
    { label: 'Active', value: activeRuns, icon: '◎', color: '#4ade80' },
    { label: 'Completed', value: completedRuns, icon: '✓', color: '#60a5fa' },
    { label: 'Failed', value: failedRuns, icon: '✗', color: '#ef4444' },
    { label: 'Outsourced', value: outsourcedRuns, icon: '☁', color: '#a78bfa' },
    { label: 'Tokens Used', value: totalTokens.toLocaleString(), icon: '◇', color: '#fbbf24' },
  ]
</script>

<div class="stats-panel grid grid-4">
  {#each stats as stat}
    <div class="stat-card glass" style="--stat-color: {stat.color}">
      <div class="stat-icon">{stat.icon}</div>
      <div class="stat-content">
        <span class="stat-value">{stat.value}</span>
        <span class="stat-label">{stat.label}</span>
      </div>
    </div>
  {/each}
</div>

<style>
  .stats-panel {
    gap: 12px;
  }

  .stat-card {
    display: flex;
    align-items: center;
    gap: 14px;
    padding: 16px 20px;
    border-radius: var(--radius-md);
  }

  .stat-icon {
    font-size: 24px;
    opacity: 0.8;
    color: var(--stat-color);
  }

  .stat-content {
    display: flex;
    flex-direction: column;
  }

  .stat-value {
    font-size: 22px;
    font-weight: 700;
    color: var(--text-primary);
    line-height: 1.2;
  }

  .stat-label {
    font-size: 11px;
    color: var(--text-muted);
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }
</style>